import ModalUpsell from "./components/ModalUpsell/ModalUpsell";

function App() {
    return <ModalUpsell />;
}

export default App;
